<template>
  <div>
    <div
      v-if="alert.message"
      :class="`alert ${alert.type}`"
    >
      {{ alert.message }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Alert",
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  watch: {
    /* eslint-disable */
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    }
    /* eslint-enable */
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear"
    })
  }
};
</script>
